import type { Enums } from "@/enums";
import * as devalue from "devalue";
import { isNotNil } from "es-toolkit";
import { defineRoute } from "../../common/route.common";
import { loadView } from "../../common/view.common";

export const ResellerInvoiceRoutes = defineRoute({
    record: {
        route: {
            path: "/reseller-invoice",
            component: () => loadView(import("./ResellerInvoiceTable.vue")),
        },
        build(filter?: { status?: Enums.InvoiceStatusEnum.Values }) {
            if (isNotNil(filter)) {
                const encoded = btoa(devalue.stringify(filter));
                return `/reseller-invoice?&filter=${encoded}`;
            }

            return "/reseller-invoice";
        },
    },
    create: {
        route: {
            path: "/reseller-invoice/create/:resellerId?",
            component: () => loadView(import("./ResellerInvoiceCreate.vue")),
        },
        build(params: { resellerId?: string }) {
            if (isNotNil(params.resellerId)) {
                return `/reseller-invoice/create/${params.resellerId}`;
            }

            return "/reseller-invoice/create";
        },
    },
    detail: {
        route: {
            path: "/reseller-invoice/detail/:id",
            component: () => loadView(import("./ResellerInvoiceDetail.vue")),
        },
        build(id: string) {
            return `/reseller-invoice/detail/${id}`;
        },
    },
});
